// Settings.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Settings() {
    return (
        <PageLayout title="Settings" subtitle="Settings overview">
            <div className="container flex col box-container">
                {/* <div className="box">Settings</div> */}
            </div>
        </PageLayout>   
    );
}

export default Settings;
